import { Injectable } from "@angular/core";
import * as moment from "moment";
import { Platform } from "@ionic/angular";
import { Subject } from "rxjs";
import { BehaviorSubject } from "rxjs";
import { LocalNotifications } from "@capacitor/local-notifications";
import { Preferences } from "@capacitor/preferences";

@Injectable({
	providedIn: "root",
})
export class TimerService {
  getTimer: Subject<any> = new BehaviorSubject<any>({});
  progressCircle: any;
  isPlaying = false;
  interval: any;
  timer = 0;
  points = 0;
  pointLap = 900;
  timerLap = 3600;
  timeText = "00:00:00";
  currentLap = 1;

  constructor(private platform: Platform) {}

  async init() {
    this.platform.resume.subscribe(() => {
      this.startProcess();
    });
    this.startProcess();
  }

  async startProcess() {
    const timer = await Preferences.get({ key: "timer" });
    const startTime = await Preferences.get({ key: "startTime" });
    if (timer.value && !startTime.value) {
      this.timer = parseInt(timer.value);
      this.timeText = moment()
        .startOf("day")
        .seconds(this.timer)
        .format("HH:mm:ss");
      this.getTimer.next({
        timer: this.timer,
        timeText: this.timeText,
      });
      if (this.progressCircle) {
        const percetage = (this.timer * 100) / this.timerLap;
        this.progressCircle.animate(percetage / 100, {
          duration: 800,
        });
        this.progressCircle.text.innerHTML = this.timeText;
      }
    } else if (timer.value && startTime.value) {
      this.timer = parseInt(timer.value);
      this.timeText = moment()
        .startOf("day")
        .seconds(this.timer)
        .format("HH:mm:ss");
      const now = new Date().getTime();
      const started = new Date(parseInt(startTime.value)).getTime();
      const diff = Math.floor((now - started) / 1000);
      this.timer = this.timer + diff;
      this.timeText = moment()
        .startOf("day")
        .seconds(this.timer)
        .format("HH:mm:ss");
      this.getTimer.next({
        timer: this.timer,
        timeText: this.timeText,
      });
      if (this.progressCircle) {
        const percetage = (this.timer * 100) / this.timerLap;
        this.progressCircle.animate(percetage / 100, {
          duration: 800,
        });
        this.progressCircle.text.innerHTML = this.timeText;
      }
      this.start();
    } else if (!timer.value && startTime.value) {
      const now = new Date().getTime();
      const started = new Date(parseInt(startTime.value)).getTime();
      const diff = Math.floor((now - started) / 1000);
      this.timer = diff;
      this.timeText = moment()
        .startOf("day")
        .seconds(this.timer)
        .format("HH:mm:ss");
      this.getTimer.next({
        timer: this.timer,
        timeText: this.timeText,
      });
      this.start();
    }
  }

  async start() {
    const firstNotification = 900 - this.timer;
    if (firstNotification > 0) {
      const response = await LocalNotifications.checkPermissions();
      if (response.display !== "granted") {
        await LocalNotifications.requestPermissions();
      }
      LocalNotifications.schedule({
        notifications: [
          {
            id: 1,
            title: "Has realizado 15 minutos de Daimoku",
            body: "",
            schedule: {
              at: new Date(new Date().getTime() + firstNotification * 1000),
            },
          },
        ],
      });
    }
    const secondNotification = 1800 - this.timer;
    if (secondNotification > 0) {
      const response = await LocalNotifications.checkPermissions();
      if (response.display !== "granted") {
        await LocalNotifications.requestPermissions();
      }
      LocalNotifications.schedule({
        notifications: [
          {
            id: 2,
            title: "Has realizado 30 minutos de Daimoku",
            body: "",
            schedule: {
              at: new Date(new Date().getTime() + secondNotification * 1000),
            },
          },
        ],
      });
    }
    const thirdNotification = 2700 - this.timer;
    if (thirdNotification > 0) {
      const response = await LocalNotifications.checkPermissions();
      if (response.display !== "granted") {
        await LocalNotifications.requestPermissions();
      }
      LocalNotifications.schedule({
        notifications: [
          {
            id: 3,
            title: "Has realizado 45 minutos de Daimoku",
            body: "",
            schedule: {
              at: new Date(new Date().getTime() + thirdNotification * 1000),
            },
          },
        ],
      });
    }
    for (let round = 1; round < 11; round++) {
      const hours = 3600 * round;
      const timeElapsed = this.timer % hours;
      const quarterNotification = hours - timeElapsed;
      if (quarterNotification > 0) {
        const response = await LocalNotifications.checkPermissions();
        if (response.display !== "granted") {
          await LocalNotifications.requestPermissions();
        }
        LocalNotifications.schedule({
          notifications: [
            {
              id: round + 10,
              title: `Has realizado ${round} hora${
                round > 1 ? "s" : ""
              } de Daimoku`,
              body: "",
              schedule: {
                at: new Date(new Date().getTime() + quarterNotification * 1000),
              },
            },
          ],
        });
      }
    }

    this.isPlaying = true;
    const startTime = await Preferences.get({ key: "startTime" });
    if (!startTime.value) {
      await Preferences.set({ key: "startTime", value: Date.now().toString() });
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
    try {
      const response = await LocalNotifications.checkPermissions();
      if (response.display !== "granted") {
        await LocalNotifications.requestPermissions();
      }
      await LocalNotifications.schedule({
        notifications: [
          {
            id: 999,
            title: "Estás haciendo Daimoku",
            body: `Has click aqui para ver`,
            ongoing: true,
            sound: null,
          },
        ],
      });
    } catch(err) {
      console.log("🚀 ~ TimerService ~ start ~ err:", err)
    }

    this.interval = setInterval(async () => {
      this.timer++;
      this.timeText = moment()
        .startOf("day")
        .seconds(this.timer)
        .format("HH:mm:ss");
      this.getTimer.next({
        timer: this.timer,
        timeText: this.timeText,
      });
      if (this.timer > this.pointLap * this.currentLap) {
        this.currentLap += 1;
        this.points += 1;
      }
      if (this.progressCircle) {
        const percetage = (this.timer * 100) / this.timerLap;
        this.progressCircle.animate(percetage / 100, {
          duration: 800,
        });
        this.progressCircle.text.innerHTML = this.timeText;
      }
    }, 1000);
  }

  async pause() {
    LocalNotifications.cancel({
      notifications: [
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 10 },
        { id: 11 },
        { id: 12 },
        { id: 13 },
        { id: 14 },
        { id: 15 },
        { id: 16 },
        { id: 17 },
        { id: 18 },
        { id: 19 },
        { id: 20 },
        { id: 999 },
      ],
    });
    this.isPlaying = false;
    clearInterval(this.interval);
    this.interval = null;
    await Preferences.set({ key: "timer", value: this.timer.toString() });
    await Preferences.remove({ key: "startTime" });
  }

  async reset() {
    this.isPlaying = false;
    clearInterval(this.interval);
    this.interval = null;
    this.points = 0;
    this.timer = 0;
    this.currentLap = 1;
    this.timeText = "00:00:00";
    this.getTimer.next({
      timer: 0,
      timeText: "00:00:00",
    });
    await Preferences.remove({ key: "startTime" });
    await Preferences.remove({ key: "timer" });
    // Cancelar la notificación permanente
    LocalNotifications.cancel({
      notifications: [{ id: 999 }],
    });
  }
}
